import { computed } from "vue"
import axios from "axios"
import { useQuery } from "@tanstack/vue-query"

const countriesEUR = [
  "AD", "AL", "AT", "AX", "BA", "BE", "BG", "CH", "CZ", "DE", "DK", "EE", "ES", "FI",
  "FR", "GB", "GF", "GG", "GI", "GP", "GR", "HR", "HU", "IC", "IE", "IM", "IS", "IT", "JE",
  "LI", "LT", "LU", "LV", "MC", "ME", "MK", "MQ", "MT", "NC", "NL", "NO", "PL", "PM", "PT", "RE", "RO", "RS",
  "SE", "SI", "SK", "SM", "TF", "TR", "UK", "VA", "WF", "YT",
]

const useVisitor = () => {
  const { isFetching, data } = useQuery({
    queryKey: ["fetchVisitor"],
    async queryFn() {
      const { data } = await axios.get("https://userinfo-staging.paessler.com/api/enrich/simple")
      return data
    },
    placeholderData: () => ({}),
  })

  const visitor = computed(() => {
    const ipInfo = data.value.IP2Location
    if (ipInfo) {
      return {
        countryCode: ipInfo.CountryCode,
        currencyCode: countriesEUR.includes(ipInfo.CountryCode) ? "EUR" : "USD",
        latitude: ipInfo.Latitude,
        longitude: ipInfo.Longitude,
      }
    }
    return {}
  })

  return {
    isFetching,
    visitor,
  }
}

export {
  useVisitor,
}
